let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ihsBG")).then(() => parcelRequire('62s6G'));